import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { importBO } from './reports.model';
import { DataStateChangeEventArgs } from '@syncfusion/ej2-angular-grids';
import { Subject } from 'rxjs/Subject';

import { GlobalComponent } from 'src/app/global/global.component';
import { GeneralService } from 'src/app/service/general.service';

@Injectable()

export class reportdata extends Subject<DataStateChangeEventArgs>{
  constructor(private http: HttpClient, public global: GlobalComponent, public general: GeneralService) {
    super();
  }
  public execute(state: importBO): void {
    this.getList(state).subscribe(x => super.next(x));
  }

  getList(state?: importBO): Observable<DataStateChangeEventArgs> {
    return this.http.post<any>("api/Import/Getspendown", state)
      .pipe(map(
        (response: any) => (<any>{
          idList: response['selectAll'],
          result: response['spendown'],
          count: response['totalCount']
        }))


      )
  }
}
